import {
  eed_mario_icon_folder_code_area,
  eed_mario_icon_folder_excel_area,
  eed_mario_icon_folder_pdf_area,
  eed_mario_icon_folder_word_area,
  eed_web_icon_global_05_folder_pdf_area,
  eed_web_icon_global_05_folder_radio_area,
  eed_web_icon_global_05_folder_txt_area,
  eed_web_icon_global_05_folder_video_area,
  eed_mario_icon_folder_html_area,
  eed_mario_icon_folder_markdown_area,
} from '@src/assets/icons';

export const ATTACHMENT_SUPPORT_TYPE = [
  {
    reg: /\.(png|jpe?g|webp|heic|heif|gif)$/i,
    type: 'image',
    icon: eed_web_icon_global_05_folder_pdf_area,
    accept: 'image/png,image/jpeg,image/webp,image/heic,image/heif',
  },
  {
    reg: /\.(mp4|mpeg|mov|avi|flv|mpg|webm|wmv|3gp)$/i,
    type: 'video',
    icon: eed_web_icon_global_05_folder_video_area,
    accept:
      'video/mp4,video/mpeg,video/mov,video/quicktime,video/avi,video/x-flv,video/mpg,video/webm,video/wmv,video/3gpp,video/x-ms-wmv',
  },
  {
    reg: /\.(wav|mp3|aiff|aac|ogg|flac|m4a)$/i,
    type: 'audio',
    icon: eed_web_icon_global_05_folder_radio_area,
    accept: 'audio/wav,audio/mp3,audio/aiff,audio/aac,audio/ogg,audio/flac',
  },
  {
    reg: /\.(pdf)$/i,
    type: 'pdf',
    icon: eed_web_icon_global_05_folder_pdf_area,
    accept: 'application/pdf',
  },
  {
    reg: /\.txt$/i,
    type: 'txt',
    icon: eed_web_icon_global_05_folder_txt_area,
    accept: 'text/plain',
  },
  {
    reg: /\.md$/i,
    type: 'md',
    icon: eed_mario_icon_folder_markdown_area,
    accept: 'text/md,.md',
  },
  {
    reg: /\.(csv|sheet|metaSheet)$/i,
    type: 'csv',
    icon: eed_mario_icon_folder_excel_area,
    accept: 'text/csv',
  },
  {
    reg: /\.(docx|doc|cloud_doc)?$/i,
    type: 'word',
    icon: eed_mario_icon_folder_word_area,
    accept:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  {
    reg: /\.(pptx|powerPoint|ppt)?$/i,
    type: 'ppt',
    icon: eed_mario_icon_folder_pdf_area,
    accept:
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  {
    reg: /\.xlsx?$/i,
    type: 'excel',
    icon: eed_mario_icon_folder_excel_area,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  {
    reg: /\.html?$/i,
    type: 'code',
    icon: eed_mario_icon_folder_html_area,
    accept: 'text/html',
  },
  // 兜底匹配，如果没命中以上任意，走该reg
  {
    reg: /$/i,
    type: 'code',
    icon: eed_mario_icon_folder_code_area,
    accept: 'text/code',
  },
];

export const ATTACHMENT_SUPPORT_TYPE_MAP = ATTACHMENT_SUPPORT_TYPE.reduce(
  (acc, item, index) => {
    acc = acc + (index === 0 ? '' : ',') + item.accept;
    return acc;
  },
  '',
);

export const TAG_MAP = {
  blockcollapse: 'BlockCollapse',
  toolcall: 'ToolCall',
  stepprocess: 'StepProcess',
  takeover: 'TakeOver',
  schedulerform: 'SchedulerForm',
  schedulercard: 'SchedulerTaskCard',
  schedulerrunnotification: 'SchedulerRunNotification',
};
